// App.js
import React from "react";
import Dashboard from "./components/Dashboard";
import { AppShell } from "@1823-partners/core";
import api from "./api";

export default function App() {
  return (
    <AppShell appName="pricing" title="Pricing" api={api}>
      {({ userInfo }) => <Dashboard userId={userInfo?.userDetails} />}
    </AppShell>
  );
}
